export const dailyBreadText = {
  en: { title: "Today's Reading", topic: 'Topic', key_verse: 'Key Verse', emphasis: 'Emphasis',
        musing: 'Musing', prayer: 'Prayer', hymn: 'Hymn',
        ls: 'Life-study Message', lsAudio: 'Life-study Broadcast',
        show: 'Tap to expand', hide: 'Tap to collapse', lyrics: 'Lyrics' },
  zh: { title: '今日讀經', topic: '主題', key_verse: '要節', emphasis: '重點',
        musing: '默想', prayer: '禱告', hymn: '詩歌',
        ls: '生命讀經', lsAudio: '生命讀經廣播',
        show: '點擊展開', hide: '點擊收合', lyrics: '歌詞' },
  sc: { title: '今日读经', topic: '主题', key_verse: '要节', emphasis: '重点',
        musing: '默想', prayer: '祷告', hymn: '诗歌',
        ls: '生命读经', lsAudio: '生命读经广播',
        show: '点击展开', hide: '点击收合', lyrics: '歌词' },
};
